/*
 * Copyright (c) 2026 GS Elektromedizinische Geraete G. Stemple GmbH, Germany - all rights reserved.
 * <p>
 * DO NOT ALTER OR REMOVE COPYRIGHT NOTICES OR THIS FILE HEADER.
 */

import React from 'react';
import { NodeType } from '../../../../backendModels/report.model';
import { SituationsAndSymptomsKeys } from '../../../../models/situationsAndSymptoms';
import { CardId } from '../../../../models/diviCard';
import SituationAndSymptoms from '../SituationAndSymptoms/SituationAndSymptoms';

interface TreatmentSituationProps {
  readonly nodeType: NodeType;
}

const treatmentSituationKeys = [
  SituationsAndSymptomsKeys.zuvorUnabhaengig,
  SituationsAndSymptomsKeys.zuvorPflegeZuhause,
  SituationsAndSymptomsKeys.zuvorPflegeInInstitution,
];

export default function TreatmentSituation({ nodeType }: TreatmentSituationProps) {
  return (
    <SituationAndSymptoms
      nodeType={nodeType}
      situationAndSymptomsKeys={treatmentSituationKeys}
      cardId={CardId.TreatmentSituation}
    />
  );
}
